import { ArticleHeading4, Body2, Button } from '@cian/ui-kit';
import cn from 'clsx';
import { NBSP } from 'shared/common/constants';
import { IOffer } from 'shared/mortgageMiniCalculator/types';
import { ETestIds } from '../../constants';
import { BanksLogoList } from '../BanksLogoList';
import { OfferCardMobile } from '../OfferCardMobile';
import { getDeclension } from '../OffersSummary/utils/getDeclension';
import styles from './styles.css';

export interface IOffersPreviewProps {
  offers: IOffer[];
  bankLogosPaths: string[];
  onCtaClick: () => void;
  onCardClick: (offer: IOffer) => () => void;
}

export const OffersPreview: React.FC<IOffersPreviewProps> = ({ offers, bankLogosPaths, onCtaClick, onCardClick }) => {
  const declensionPart = getDeclension(offers.length);
  const isSingleOffer = offers.length === 1;

  return (
    <div className={styles['container']} data-testid={ETestIds.OffersPreviewContainer}>
      <div className={styles['header']}>
        <div className={styles['header-text']}>
          <ArticleHeading4>{declensionPart}</ArticleHeading4>
          <Body2 color="text-secondary-default">От банков и{NBSP}застройщиков</Body2>
        </div>
        <div className={styles['header-logos']}>
          <BanksLogoList size="S" maxLogosShown={3} banks={bankLogosPaths} withShadow={false} />
        </div>
      </div>
      <div className={cn(styles['offers-list'], isSingleOffer && styles['offers-list--single'])}>
        {offers.map((offer, index) => (
          <OfferCardMobile key={index} variant="preview" offer={offer} onClick={onCardClick(offer)} />
        ))}
      </div>
      {offers.length > 1 && (
        <Button fullWidth size="M" onClick={onCtaClick} data-testid={ETestIds.OffersPreviewShowAllButton}>
          Смотреть все предложения
        </Button>
      )}
    </div>
  );
};
